<div class="supplementary-equipment">
  <div class="dialog-layout">

    <h2 class="dialog-h2">
      <sc-dictionary-label dictionaryKey="tmc.transport.supplementaryEquipment.takeBack.title"></sc-dictionary-label>
    </h2>

    <div class="top-info">
      {{handout.name}} {{handout.firstname}} {{handout.company}}
    </div>

    <div class="dialog-content" [formGroup]="formGroup">
      <sc-flex vertical stretchContent class="no-field-space">

        @if (supplementaryEquipmendHandouted(handout)) {
          @for (se of handout.supplementaryEquipments; track se; let i = $index) {
            @if (i > 0) {
              <sc-content-spacer vertical></sc-content-spacer>
            }
            <sc-flex [formGroupName]="'' + i">
              <sc-checkbox-field [disabled]="isFormReadonly()" [label]="se.name" formControlName="selected"></sc-checkbox-field>
              @if (se.identifier != null) {
                <sc-content-spacer></sc-content-spacer>
                <sc-string-field [disabled]="true" labelDictionaryKey="tmc-common.equipment.entity.equipment.identifier" [textContent]="se.identifier"></sc-string-field>
              }
            </sc-flex>
          }
        }

        @if (!supplementaryEquipmendHandouted(handout)) {
          <div>
            <sc-dictionary-label dictionaryKey="tmc.transport.supplementaryEquipment.takeBack.label.nosupplementaryequipmenthandout"></sc-dictionary-label>
          </div>
        }

      </sc-flex>
    </div>


    <sc-actionbar>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-cancel-button class="cancel-button" (click)="cancel()"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-save-button primary (click)="save()" class="confirm-button" [disabled]="isSaveDisabled()"></sc-save-button>
    </sc-actionbar>
  </div>

</div>
